import React from 'react';
import icoGhost from '../../../../images/extra-saldo/icon_fantasma.svg';
import { CardsContainer, Card, Legend } from './styles/NoOffersStyled';

const NoOffers = () => (
  <>
    <Legend>
      <h4>No encontramos oferta para mostrar</h4>
      <p>Por favor regresa más tarde</p>
    </Legend>
    <CardsContainer>
      {Array.from({ length: 3 }, (_, index) => (
        <Card key={index}>
          <img src={icoGhost} alt="" />
        </Card>
      ))}
    </CardsContainer>
  </>
);

export default NoOffers;
